import React, { useState, useEffect } from "react";
import api from "../../../api";
import Banner from "./include/Banner";
import './Research.css';

// Define the API URL for convenience
const API_URL = `${process.env.REACT_APP_API_URL}/api/research`;
const API_BASE_URL = process.env.REACT_APP_API_URL;

const ResearchOverview = () => {
    const [researchData, setResearchData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    // Fetch data from API
    useEffect(() => {
        const fetchResearchData = async () => {
            try {
                const response = await api.get(API_URL);
                setResearchData(response.data);
            } catch (err) {
                console.error("Error fetching research data:", err);
                setError("Failed to load research data.");
            } finally {
                setLoading(false);
            }
        };

        fetchResearchData();
    }, []);

    if (loading || error) {
        return null;
    }
    // Destructure data for easier access, providing fallbacks for safety
    const bannerContent = researchData?.banner?.content || { images: [], heading: "Research" };
    const overviewContent = researchData?.overview?.content || { image: null, content: "<p>Content not available.</p>" };

    // Function to safely render HTML content (e.g., the overview paragraph)
    const createMarkup = (htmlContent) => {
        return { __html: htmlContent };
    };

    // Construct the full URL for the overview image
    const overviewImageUrl = overviewContent.image ? `${API_BASE_URL}/public/${overviewContent.image}` : '';

    return (
        <>
            {/* Pass banner data as props to the Banner component */}
            <Banner
                bannerImages={bannerContent.images}
                heading={bannerContent.heading}
            />

            <section>
                <div className="container ">
                    <div className="row mb-5">
                        <div className="col-md-12">
                            <div className="res-content"><div className="sec-title text-center"><h2>Research Overview</h2></div>
                               

                              <div className="row d-flex justify-content-center align-items-center">

    {/* Text column */}
    <div
        className={
            overviewImageUrl
                ? "col-md-8 col-12 order-2 order-md-1"
                : "col-md-12 col-12"
        }
    >
        <div

            dangerouslySetInnerHTML={createMarkup(overviewContent.content)}
        />
    </div>

    {/* Image column */}
    {overviewImageUrl && (
        <div className="col-md-4 col-12 text-center order-1 order-md-2">
            <img
                src={overviewImageUrl}
                alt="Research Facility"
                className="img-fluid mb-3 mb-md-0"

                style={{ borderRadius: "10px" }}
            />
        </div>
    )}

</div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ResearchOverview;



